import { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { Desktop, Mobile } from '../../App';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import Spinner from '../../components/common/Spinner';
import { BACKOFFICE_NAME } from '../../helpers/helperFunctions';

import {
  KYC_START,
  MARKETPLACE,
  SETTINGS_SECURITY,
  SETTINGS_VIRTUAL_OFFICE
} from '../../routes/routes';
import { color, colors } from '../../styles/GlobalStyles';
import { getDashboardInfo, updateWillyCoins } from './Dashboard.actions';
import { PackageRankUpgradeNotification } from './Dashboard.types';
import { DashboardNotification } from './DashboardNotification';
import { EarningsComponent } from './EarningsComponent';

import { RankNotification } from './RankNotification';
import { StatisticalComponent } from './StatisticalComponent';
import { SubscriptionWarning } from './SubscriptionWarning';

import bigHearts from '../../assets/images/backoffice/bigHearts/bigHeartsBanner.png';
import bigHeartsMobile from '../../assets/images/backoffice/bigHearts/bigHeartsBannerMobile.png';

const Dashboard = () => {
  const dispatch = useAppDispatch();

  const { t } = useTranslation('dashboard');
  const { user, kycStatus } = useAppSelector((state) => state.auth.userInfo);

  const { dashboardInfo, loading } = useAppSelector((state) => state.dashboard);

  const history = useHistory();

  useEffect(() => {
    dispatch(getDashboardInfo());
  }, [dispatch]);

  const StartYourJourneyNotification = () => {
    if (!dashboardInfo?.user?.currentVirtualOfficeLicence) {
      return (
        <DashboardNotification
          pill={'take the first step today'}
          title={'Start your Journey HERE!'}
          text={`To achieve the fastest growth, start with the MaVie ${BACKOFFICE_NAME} Subscription.`}
          buttonText={`Start with a ${BACKOFFICE_NAME}`}
          buttonOnClick={() => history.push(SETTINGS_VIRTUAL_OFFICE)}
        />
      );
    } else return null;
  };

  if (loading && !dashboardInfo) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'dashboardInfo'}>
      <StartYourJourneyNotification />

      {dashboardInfo?.packageRankUpgradeNotifications?.map(
        (notification: PackageRankUpgradeNotification, index: number) => {
          return <RankNotification notification={notification} key={index} />;
        }
      )}

      <Link to={MARKETPLACE}>
        <Desktop>
          <img
            src={bigHearts}
            alt='powerPack'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Desktop>
        <Mobile>
          <img
            src={bigHeartsMobile}
            alt='powerPack'
            style={{ width: '100%', borderRadius: 12, marginBottom: 40 }}
          />
        </Mobile>
      </Link>

      <SubscriptionWarning />

      <EarningsComponent user={user} backOffice={dashboardInfo} />

      <StatisticalComponent backOffice={dashboardInfo} />
    </AnimatedDashboard>
  );
};

export default Dashboard;
